// Takes an object and makes sure the values are not null or undefined f
type AnyObject = Record<string, any>;

const sanitizeObject = (obj: AnyObject): AnyObject => {
  return Object.keys(obj).reduce((sanitized: AnyObject, key: string) => {
    const value = obj[key];
    sanitized[key] = value ?? "";
    return sanitized;
  }, {});
};
export default sanitizeObject;
